// PSD-CHECKOUT-LEAD-SAVE-001 — run database-heavy checkout functions next to
// the database.
//
// Supabase runs an Edge Function in the region closest to the CALLER. The
// database (TEST and LIVE) lives in us-east-2, so a customer served from
// us-west-1, ap-south-1 or ap-southeast-1 pays a cross-continent round trip
// for EVERY sequential query the function makes. The checkout functions make
// many (create-payment-intent ~10-12 in series).
//
// Measured on TEST (same request, 4 runs each): get-resume-order 1.4–2.3 s
// from ap-southeast-1 vs 0.5–0.8 s pinned to us-east-1.
//
// us-east-1 is the closest region Supabase offers to us-east-2. The query
// parameter (not the x-region header) is used on purpose: it needs no CORS
// change. Trade-off, per Supabase docs: a pinned call is NOT re-routed if that
// region has an outage — remove the pin here to fall back to nearest-region.
export const DB_FUNCTION_REGION = "us-east-1";

/** Append the region pin to an Edge Function URL. */
export function withDbRegion(url: string): string {
  return `${url}${url.includes("?") ? "&" : "?"}forceFunctionRegion=${DB_FUNCTION_REGION}`;
}
